import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export function CallHistoryPagination({
  pagina,
  totalPaginas,
  total,
  rawCount,
  limite,
  cambiarLimite,
  setPagina,
  loading,
}) {
  if (total <= 0) return null;

  const inicio = Math.min((pagina - 1) * (limite || 25) + 1, total);
  const fin = Math.min(inicio + rawCount - 1, total);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-3 pt-3 border-t border-slate-200/80 text-xs text-slate-500">
      {/* Contador de filas y Selector de Filas por Página */}
      <div className="flex items-center gap-3">
        <div>
          Mostrando <span className="font-bold text-slate-800">{inicio} - {fin}</span> de{' '}
          <span className="font-bold text-slate-800">{total}</span> llamadas registradas
        </div>

        {cambiarLimite && (
          <div className="flex items-center gap-1.5 pl-3 border-l border-slate-200">
            <span className="text-[11px] text-slate-400">Filas:</span>
            <select
              value={limite || 25}
              onChange={(e) => cambiarLimite(Number(e.target.value))}
              disabled={loading}
              className="bg-white border border-slate-200 text-slate-700 text-xs font-semibold rounded-lg px-2 py-0.5 focus:outline-hidden focus:ring-1 focus:ring-indigo-500 cursor-pointer"
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
        )}
      </div>

      {/* Controles de Navegación de Páginas */}
      <div className="flex items-center gap-1.5">
        <button
          type="button"
          onClick={() => setPagina((p) => Math.max(1, p - 1))}
          disabled={pagina <= 1 || loading}
          className="px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-40 disabled:hover:bg-white text-slate-700 font-bold transition flex items-center gap-1 cursor-pointer shadow-2xs"
        >
          <ChevronLeftIcon className="w-3.5 h-3.5" />
          Anterior
        </button>

        <span className="px-2.5 py-1 font-mono font-bold text-slate-700 bg-slate-100 rounded-lg text-xs">
          {pagina} / {totalPaginas}
        </span>

        <button
          type="button"
          onClick={() => setPagina((p) => Math.min(totalPaginas, p + 1))}
          disabled={pagina >= totalPaginas || loading}
          className="px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 disabled:opacity-40 disabled:hover:bg-white text-slate-700 font-bold transition flex items-center gap-1 cursor-pointer shadow-2xs"
        >
          Siguiente
          <ChevronRightIcon className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
